import { create } from 'zustand';
import { Collection, Dataset } from '@/types/source-types';

interface DataSourcesStore {
  currentCollection: Collection | null;
  setCurrentCollection: (collection: Collection | null) => void;
  currentDataset: Dataset | null;
  setCurrentDataset: (dataset: Dataset | null) => void;
}

export const useDataSourcesStore = create<DataSourcesStore>((set) => ({
  currentCollection: null,
  setCurrentCollection: (collection) => set({ currentCollection: collection }),
  currentDataset: null,
  setCurrentDataset: (dataset) => set({ currentDataset: dataset }),
}));
